module.exports = __webpack_public_path__ + "images/file_icons_v2/odt-0ebbf81edd98427e68332dc0f1b4e3d7.svg";